import { ConfigCommonHeader } from '@net7/boilerplate-common';

export default {
  logo: {
    title: 'Petrarca Online',
    anchor: {
      href: '/',
    },
  },
  nav: {
    items: [],
  },
} as ConfigCommonHeader;
